import { Sidebar as ShadSidebar, SidebarProvider } from '@/components/ui/sidebar'
import SidebarFooter from '@app/layout/Sidebar/SidebarFooter'
import { SidebarLogo } from '@app/layout/Sidebar/SidebarLogo'
import { SidebarMenu } from '@app/layout/Sidebar/SidebarMenu'
import { SidebarAtom } from '@app/state/layoutAtom'
import { useAtom } from 'jotai'
import React from 'react'

const Sidebar = () => {
  const [isOpen, setIsOpen] = useAtom(SidebarAtom)

  return (
    <SidebarProvider
      open={isOpen}
      onOpenChange={setIsOpen}
      style={
        {
          '--sidebar-width': '224px',
          '--sidebar-width-icon': '48px',
          display: 'contents',
        } as React.CSSProperties
      }
    >
      <ShadSidebar collapsible="icon" className="border-r border-darkBlue-700 text-white">
        <SidebarLogo />
        <SidebarMenu />
        <SidebarFooter />
      </ShadSidebar>
    </SidebarProvider>
  )
}

export default Sidebar
